import { getStatsigGateValue } from 'util/statsig';

/**
 * Statsig gate backing the Data Plus entitlement **for now**. This is the single
 * place the entitlement source is decided — swap the hook body below if it ends
 * up coming from client config (a `guestJourney.enabledDataPlus` sub-flag) or
 * somewhere else entirely.
 */
export const DATA_PLUS_GATE = 'guest-journey-data-plus';

/**
 * Whether the current client is entitled to Data Plus (Retention + Benchmarks).
 * When `false`, those tabs must show the entitlement modal over a blurred,
 * non-fetching preview — see `DataPlusGate`.
 *
 * Sourced from a statsig gate today (runtime-togglable, consistent with the
 * `dashboard-guest-journey` route gate). The Guest Journey route already gates
 * on statsig, so the client is loaded by the time these tabs render and this
 * reads synchronously. Kept as a hook so the source can change without touching
 * any call site.
 */
export const useDataPlusEntitlement = (): boolean =>
  getStatsigGateValue(DATA_PLUS_GATE);
